// src/layouts/FrontendLayout.tsx

import React, { ReactNode, useEffect } from 'react';
import FrontendHeader from '../frontend/FrontendHeader';
import FrontendFooter from '../frontend/FrontendFooter';

interface FrontendLayoutProps {
  children: ReactNode;
}

const FrontendLayout: React.FC<FrontendLayoutProps> = ({ children }) => {
  useEffect(() => {
    const basePath = process.env.PUBLIC_URL || '';
    const scriptsToLoad = [
      `${basePath}/frontend/js/swiper-bundle.min.js`,
      `${basePath}/frontend/js/swiper.js`,
      `${basePath}/frontend/js/infinityslide.js`,
    ];


    const loadScript = (url: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = false; // maintain order
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
        document.body.appendChild(script);
      });
    };

    const loadAllScriptsSequentially = async () => {
      for (const scriptUrl of scriptsToLoad) {
        try {
          await loadScript(scriptUrl);
        } catch (error) {
          console.error(error);
        }
      }

      // AFTER loading these, run your init
      if ((window as any).initFrontendPlugins) {
        (window as any).initFrontendPlugins();
      } else {
        console.warn('initFrontendPlugins not found on window.');
      }
    };

    loadAllScriptsSequentially();

    // Clean up: remove the injected scripts on unmount
    return () => {
      scriptsToLoad.forEach(scriptUrl => {
        const scriptElements = document.querySelectorAll(`script[src="${scriptUrl}"]`);
        scriptElements.forEach(script => script.remove());
      });
    };
  }, []);

  return (
    <>
      <FrontendHeader />
      <main>{children}</main>
      <FrontendFooter />
    </>
  );
};

export default FrontendLayout;
